export const MuiPopper = {
    styleOverrides: {
        root: ({ theme }) => ({
            zIndex: theme.zIndex.tooltip,
        }),
    },
};
